import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/logo.jpeg';
const _withScopeId = n => (_pushScopeId("data-v-2386c475"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "setup"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "setup_head"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_3 = {
  class: "cont"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "name"
}, "昵称", -1));
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "name"
}, "修改登陆密码", -1));
const _hoisted_7 = {
  class: "text"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_9 = {
  class: "bottom"
};
const _hoisted_10 = {
  style: {
    "margin": "16px",
    "margin-top": "50px"
  }
};
const _hoisted_11 = {
  style: {
    "margin": "16px",
    "margin-top": "50px"
  }
};
import nav_header from '@/components/nav_header.vue';
import { change } from '@/util/http';
import { showToast } from 'vant';
import 'vant/es/toast/style';

import { useRouter } from 'vue-router';
import { ref, reactive, onBeforeMount } from 'vue';
export default {
  __name: 'setup',
  setup(__props) {
    const router = useRouter();
    let show = ref(false);
    let nicknameEixt = ref(true);
    let nickname = ref('');
    let old_password = ref('');
    let password = ref('');
    let passwords = ref('');
    let userInfo = reactive({});
    onBeforeMount(() => {
      userInfo = JSON.parse(localStorage.getItem('userInfo'));
      nickname.value = userInfo.nickname;
    });
    let getup = () => {
      localStorage.removeItem('userInfo');
      localStorage.removeItem('Authorization');
      localStorage.removeItem('char');
      router.push({
        path: `/login`
      });
    };
    let eixt = e => {
      show.value = true;
      if (e) {
        nicknameEixt.value = true;
      } else {
        nicknameEixt.value = false;
      }
    };
    let onSubmit = () => {
      change({
        nickname: nickname.value
      }).then(res => {
        console.log(res);
        if (res.message == '更新成功') {
          userInfo.nickname = nickname.value;
          show.value = false;
          showToast(res.message);
          localStorage.setItem('userInfo', JSON.stringify(res.data.user));
          localStorage.setItem(res.data.token_type, res.data.token);
        } else {
          showToast(res.message);
        }
      });
    };
    let onSubmits = () => {
      if (password.value == '' || passwords.value == "" || old_password.value == '') {
        showToast('密码不能为空');
      } else if (password.value != passwords.value) {
        showToast('两次密码不一致');
      } else {
        change({
          password: password.value,
          old_password: old_password.value
        }).then(res => {
          show.value = false;
          showToast(res.message);
          router.push({
            path: `/login`
          });
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "我的设置"
      }), _createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [_createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = $event => _unref(eixt)(1))
      }, [_hoisted_4, _createElementVNode("p", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_unref(userInfo).nickname), 1), _createVNode(_component_van_icon, {
        name: "arrow"
      })])]), _createElementVNode("li", {
        onClick: _cache[1] || (_cache[1] = $event => _unref(eixt)(0))
      }, [_hoisted_6, _createElementVNode("p", _hoisted_7, [_hoisted_8, _createVNode(_component_van_icon, {
        name: "arrow"
      })])])])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
        color: "#007539",
        type: "primary",
        round: "",
        size: "large",
        onClick: _unref(getup)
      }, {
        default: _withCtx(() => [_createTextVNode("退出登陆")]),
        _: 1
      }, 8, ["onClick"])])]), _createVNode(_component_van_overlay, {
        show: _unref(show)
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[8] || (_cache[8] = _withModifiers($event => _isRef(show) ? show.value = false : show = false, ["stop"]))
        }, [_unref(nicknameEixt) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wrapperbox",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [_createVNode(_component_van_form, {
          onSubmit: _unref(onSubmit)
        }, {
          default: _withCtx(() => [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_van_field, {
              modelValue: _unref(nickname),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(nickname) ? nickname.value = $event : nickname = $event),
              name: "昵称",
              label: "昵称",
              placeholder: "请输入要修改的昵称",
              rules: [{
                required: true,
                message: '请输入要修改的昵称'
              }]
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            color: "#007539",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [_createTextVNode(" 提交 ")]),
            _: 1
          })])]),
          _: 1
        }, 8, ["onSubmit"])])) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "wrapperbox",
          onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
        }, [_createVNode(_component_van_form, {
          onSubmit: _unref(onSubmits)
        }, {
          default: _withCtx(() => [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_van_field, {
              modelValue: _unref(old_password),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(old_password) ? old_password.value = $event : old_password = $event),
              name: "旧密码",
              label: "旧密码",
              placeholder: "请输入旧密码",
              rules: [{
                required: true,
                message: '请输入旧密码'
              }]
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_van_field, {
              modelValue: _unref(password),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(password) ? password.value = $event : password = $event),
              name: "新密码",
              label: "新密码",
              placeholder: "请输入新密码",
              rules: [{
                required: true,
                message: '请输入新密码'
              }]
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_van_field, {
              modelValue: _unref(passwords),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(passwords) ? passwords.value = $event : passwords = $event),
              name: "确认密码",
              label: "确认密码",
              placeholder: "请再次输入新密码",
              rules: [{
                required: true,
                message: '请再次输入新密码'
              }]
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            color: "#007539",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [_createTextVNode(" 确认修改 ")]),
            _: 1
          })])]),
          _: 1
        }, 8, ["onSubmit"])]))])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};